import React from 'react';
import { terms } from '../../agent-metrics/constants';
import { Button } from '@lwt-helix/buttons';
import { navigateToPlatformHome } from '../../constants/nav';

export const VerificationError = () =>  (
    <div className='verification-error-wrapper'>
        <div className='bg-white raised-border d-flex flex-column align-items-center p-5 mt-5'>
            <div className='text-center mb-3'>
                <img
                    height='40'
                    src='https://assets.lwolf.com/img/lw-logo-dark.svg'
                    alt='Logo'
                    className='mb-5'
                />
                <p>{terms.verificationErrorP1}</p>
                <p>{terms.verificationErrorP2}</p>
                <Button
                    dataLwtId='go-to-lone-wolf-home-button'
                    className='btn btn-primary go-to-lone-wolf-home-button w-100'
                    onClick={navigateToPlatformHome}
                >
                    {terms.goToLoneWolfHome}
                </Button>
            </div>
        </div>
    </div>
);
